import React from 'react';
import { Stack, Typography } from '@mui/material';
import { formatDateTime } from '@/components/views/SettingsView/BrokerageUsersTable/helpers';
import { UserChip } from './chips/UserChip';

/**
 * When a record (e.g. a broker group or user) was last updated, and by whom (a user chip,
 * from lastUpdatedBy's user doc id) when that's known. For the bottom of an edit drawer.
 */
export const AdminLastUpdated = ({ lastUpdated, lastUpdatedBy }) => (
	<Stack direction='row' spacing={1} alignItems='center' flexWrap='wrap' sx={{ p: 1, px: 2 }}>
		<Typography variant='body2' color='text.secondary'>
			{`Last updated ${formatDateTime(lastUpdated)}`}
		</Typography>
		{lastUpdatedBy && (
			<>
				<Typography variant='body2' color='text.secondary'>
					by
				</Typography>
				<UserChip id={lastUpdatedBy} />
			</>
		)}
	</Stack>
);
